
  import createMeisterIcons from '../src/createMeisterIcons';

  const Circle = createMeisterIcons("circle", [["path",{"fill":"currentColor","d":"M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12","key":"1d77fdcc7d662cc17e7a83d0f79bb5c6ade00a5d","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Circle
  